import { Panel, PanelType, SelectionMode, Toggle } from 'office-ui-fabric-react';
import { DetailsList } from 'office-ui-fabric-react/lib/DetailsList';
import React, { Component, Fragment } from 'react';
import { DataMandat } from '../../data/DataMandat.jsx';
import { Immocom } from '../../specifique/immocom';
import { EUITextField } from '../EUI/EUITextField.jsx';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';
import TextFieldHonoraires from '../TextField/TextFieldHonoraires';

/*
***************************************************************
 PROPS:

    idMandat : int
    estTypeCompte : bool
    onFerme : fn
 
***************************************************************
*/

var objetState = {
    listeLots: [],

    civilite: '',
    prenom: '',
    nom: '',
    tel: '',
    email: '',
    societeReseau: '',
    nbreOptionParOperation: 0,
    honoraireCommercialisation: "0",
    exclusivite: false,


    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: ''
};

export class FicheMandatCommercialisation extends Component {
    listeLotsColumns = [
        {
            key: 'Numero',
            name: 'N°',
            fieldName: 'numero',
            minWidth: 60,
            maxWidth: 85,
            isResizable: true,
        },
        {
            key: 'LotType',
            name: 'Type',
            fieldName: 'lotType',
            minWidth: 100,
            maxWidth: 200,
            isResizable: true
        },
        {
            key: 'PrixHT',
            name: 'Prix HT',
            fieldName: 'prixHT',
            minWidth: 80,
            maxWidth: 100,
            isResizable: true,
            onRender: (item) => {
                return <span title={item.prixHT.toFixed(2)}>{item.prixHT.toFixed(2)}</span>;
            }
        }];

    _creationContent = () => {

        const titrePanel = 'Detail mandat de commercialisation';
        const { civilite, prenom, nom, tel, email, honoraireCommercialisation, nbreOptionParOperation, exclusivite, societeReseau } = this.state;
        const reseau = societeReseau != null || societeReseau != 0;
        const { estTypeCompte } = this.props;

        return <Panel
            isOpen={this.props.estAffiche}
            type={PanelType.large}
            onDismiss={this._onAnnulation}
            onOpen={() => this._onOpen()}
            headerText={titrePanel}
            closeButtonAriaLabel="Fermer"
        >
            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                    {estTypeCompte ?
                        <Fragment>
                            <div className="ms-Grid-col ms-sm2">
                                <EUITextField
                                    label="Civilité"
                                    readOnly
                                    value={civilite}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm6">
                                <EUITextField
                                    label="Nom"
                                    readOnly
                                    value={nom}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm4">
                                <EUITextField
                                    label="Prénom"
                                    readOnly
                                    value={prenom}
                                />
                            </div>
                        </Fragment>
                        :
                        <div className="ms-Grid-col ms-sm12">
                            <EUITextField
                                label="Nom"
                                readOnly
                                value={nom}
                            />
                        </div>
                    }
                </div>
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm4">
                        <EUITextField
                            disabled={!estTypeCompte}
                            label="Téléphone"
                            readOnly
                            value={tel}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm8">
                        <EUITextField
                            disabled={!estTypeCompte}
                            label="E-mail"
                            readOnly
                            value={email}
                        />
                    </div>
                </div>

                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm6">
                        <Toggle
                            defaultChecked={exclusivite}
                            disabled
                            label="Allotement"
                            onText="exclusivité"
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm6">
                        <Toggle
                            defaultChecked={reseau}
                            disabled
                            label="Société réseau"
                            onText="réseau"
                        />
                    </div>
                </div>
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm6">
                        <EUITextField
                            label="Nb max options"
                            readOnly
                            title="Nombre maximum d'options simultanées autorisées"
                            value={nbreOptionParOperation}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm6">
                        <TextFieldHonoraires
                            value={honoraireCommercialisation}
                            readOnly
                        />
                    </div>
                </div>
            </div>
            <hr />
            <p className="ms-Panel-headerText headerText-182">Liste des lots</p>
            <DetailsList
                items={this.state.listeLots}
                columns={this.listeLotsColumns}
                selectionMode={SelectionMode.none}
            />
        </Panel>;
    };

    constructor(props) {
        super(props);

        this.state = objetState;
    };

    _onAnnulation = () => {
        this.setState(objetState);
        this.props.onFerme();
    };

    _chargementDonnees = () => {
        if (!this.props.idMandat) { // on ne passe pas d'id state initial idMandat:0
            return;
        }

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement du mandat de commercialisation'
        });

        DataMandat._chargementFicheMandatCommercialisation(this.props.idMandat, this.props.estTypeCompte).then(responseFetch => {
            let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

            if (retourVerif === null) {
                const objetData = responseFetch.reponseAPIobjet;
                const detail = objetData[0];
                if (!detail) {
                    this.setState({
                        hideMessageBarError: false,
                        errorMessage: 'Le format de données attendu de l\'api est incorrect'
                    });
                }
                this.setState({
                    ...detail,
                    enCoursDeTraitement: false,
                    messageEnCoursTraitement: ''
                }, this._chargementListeLot);

            }
            else {
                Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
            }
        });


    };

    _chargementListeLot = () => {
        DataMandat._chargementFicheMandatCommercialisationListeLot(this.props.idMandat).then(responseFetch => {
            let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

            if (retourVerif === null) {
                let objetData = responseFetch.reponseAPIobjet;
                this.setState({ listeLots: objetData });
            }
            else {
                Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
            }
        });
    }

    _onOpen = () => {
        this._chargementDonnees();
    };

    componentDidMount = () => {
        this._chargementDonnees();
    };


    render = () => {
        return this._creationContent();
    };
}